<template>
  <el-container class="fm2-container">
    <el-main class="fm2-main">
      <el-container>
        <!--组件操作面板-->
        <el-aside width="250px" class="widget-config-container">
          <el-container>
            <!--组件顶部页签-->
            <el-header height="45px">
              <div class="config-tabs" :class="{active: Tab=='PC'}" @click="Tab = 'PC'">PC组件</div><!--
              --><div class="config-tabs" :class="{active: Tab=='mobel'}" @click="Tab = 'mobel'">移动组件</div>
            </el-header>
            <!--组件显示区域-->
            <el-main class="config-content">
              <!--表单配置页签-->
              <div class="components-list" v-loading="comploading">
                <div v-for="(comp,c) in Tab=='PC' ? allComponents : mobelComponent" :key="c">
                  <el-collapse v-model="collapseActiveNames">
                    <el-collapse-item :title="comp.label" :name="comp.label">
                      <!-- <div class="widget-cate">{{comp.label}}</div> -->
                      <draggable
                        tag="ul"
                        :list="comp.value"
                        v-bind="{group:{ name:'people', pull:'clone',put:false},sort:false, ghostClass: 'ghost'}"
                        @end="handleMoveEnd"
                        @start="handleMoveStart"
                        :move="handleMove"
                      >
                        <li
                          class="form-edit-widget-label"
                          :class="{'no-put': item.type == 'divider'}"
                          v-for="(item, index) in comp.value"
                          :key="index"
                        >
                          <a>
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="item.name"
                              placement="top-start"
                            >
                              <i class="icon iconfont" :class="item.icon"></i>
                              <span>{{item.componentChineseName? item.componentChineseName : item.name}}</span>
                            </el-tooltip>
                          </a>
                        </li>
                      </draggable>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </div>
            </el-main>
          </el-container>
        </el-aside>

        <!--已拖拽组件操作面板-->
        <el-container class="center-container" direction="vertical">
          <div class="container-div">
            <el-header class="btn-bar" style="height: 45px;">
              <slot name="action"></slot>
              <el-button
                type="text"
                size="medium"
                icon="el-icon-s-platform"
                @click="isMobel = false"
              >PC端</el-button>
              <el-button
                type="text"
                size="medium"
                icon="el-icon-mobile-phone"
                @click="isMobel = true"
              >移动端</el-button>
              <el-button type="text" size="medium" icon="el-icon-delete" @click="handleClear">清空</el-button>
              <el-button type="text" size="medium" icon="el-icon-view" @click="handlePreview">预览</el-button>
              <el-button
                type="text"
                size="medium"
                icon="el-icon-refresh-right"
                @click="refreshkeyAdd"
              >刷新</el-button>
            </el-header>
            <!--            <img id="bgMobel" src="../../assets/mobileBg.png" alt="">-->
            <el-main
              :class="{'widget-empty': widgetForm.list.length == 0,'mobelWidth':isMobel}"
              style="text-align: left;position: relative;"
              :key="refers"
            >
              <widget-form
                v-show="!resetJson"
                :routerurl="routerurl"
                :allComponents="allComponents"
                ref="widgetForm"
                :data="widgetForm"
                :select.sync="widgetFormSelect"
                :key="refreshkey"
              ></widget-form>
            </el-main>
          </div>
        </el-container>

        <!--组件属性设置操作面板-->
        <el-aside class="widget-config-container">
          <el-container>
            <el-header height="45px">
              <div
                class="config-tab"
                :class="{active: configTab=='widget'}"
                @click="handleConfigSelect('widget')"
              >字段属性</div><!--
              --><div
                class="config-tab"
                :class="{active: configTab=='form'}"
                @click="handleConfigSelect('form')"
              >表单属性</div>
            </el-header>
            <el-main class="config-content">
              <widget-config
                v-show="configTab=='widget'"
                :data="widgetFormSelect"
                :key="'config' + refreshkey"
              ></widget-config>
              <form-config v-show="configTab=='form'" :data="widgetForm.config"></form-config>
            </el-main>
          </el-container>
        </el-aside>

        <cus-dialog
          :visible="previewVisible"
          @on-close="previewVisible = false"
          ref="widgetPreview"
          width="1000px"
          form
        >
          <generate-form
            insite="true"
            @on-change="handleDataChange"
            v-if="previewVisible"
            :data="widgetForm"
            :value="widgetModels"
            :remote="remoteFuncs"
            :remote-option="dynamicData"
            @on-province-change="onProvinceChange"
            @on-city-change="onCityChange"
            ref="generateForm"
          ></generate-form>
          <template slot="action">
            <el-button @click="previewClose">关闭</el-button>
          </template>
        </cus-dialog>
      </el-container>
    </el-main>
  </el-container>
</template>

<script>
let vm = {};
import Draggable from "vuedraggable";
import WidgetConfig from "./WidgetConfig";
import FormConfig from "./FormConfig";
import WidgetForm from "./WidgetForm";
import CusDialog from "./CusDialog";
import GenerateForm from "./GenerateForm";
import { components } from "./componentsConfig.js";
import request from "./utils/request.js";
import generateCode from "./generateCode.js";
import createVue from "./createVue.js";
import XyjVueLoader from "../../../static/XyjVueLoader.js";

export default {
  name: "fm-making-form",
  components: {
    Draggable,
    WidgetConfig,
    FormConfig,
    WidgetForm,
    CusDialog,
    GenerateForm
  },
  props: {
    preview: {
      type: Boolean,
      default: false
    },
    generateCode: {
      type: Boolean,
      default: false
    },
    generateJson: {
      type: Boolean,
      default: false
    },
    upload: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    keepaliveName: {
      type:String,
      default:''
    }
  },
  data() {
    vm = this;
    return {
      collapseActiveNames:'基础字段',
      comploading:false,
      /**
       *宋建国：2020/2/11 16:11
       *描述：控制组件显示区域强制刷新
       *版本：1.0
       */
      refreshkey: 1,
      /**
       *宋建国：2020/1/4 22:24
       *描述：远程组件列表
       *版本：1.0
       */
      remoteComponents: [],
      routerurl: "",
      allComponents: components,
      resetJson: false,
      widgetForm: {
        list: [],
        config: {
          labelWidth: 100,
          labelPosition: "right",
          size: "small",
          height: ""
        }
      },
      configTab: "widget",
      widgetFormSelect: null,
      previewVisible: false,
      remoteFuncs: {
        func_test(resolve) {
          if (vm.widgetFormSelect && vm.widgetFormSelect.type == "select") {
            let data = {}
            data.url = vm.widgetFormSelect.options.filter(item => item.attrName == "dynamicChange")[0].list[0].funcContent;
            data.method = vm.widgetFormSelect.options.filter(item => item.attrName == "dynamicChange")[0].list[0].method
            data.method == 'get' && (data.params = eval("("+vm.widgetFormSelect.options.filter(item => item.attrName == "dynamicChange")[0].list[0].data+")"))
            data.method == 'post' && (data.data = eval("("+vm.widgetFormSelect.options.filter(item => item.attrName == "dynamicChange")[0].list[0].data+")"))
            vm.axios(data).then(res => {
              if(res.data.rows){
                let optionData = res.data.rows.map(x => {
                  let obj = {};
                  obj.value = x[vm.widgetFormSelect.options.filter(item => item.attrName == "dynamicChange")[0].list[0].Value];
                  obj.label = x[vm.widgetFormSelect.options.filter(item => item.attrName == "dynamicChange")[0].list[0].Label];
                  return obj;
                });
                resolve(optionData);
              }else if(res.data.length>0){
                let optionData = res.data.map(x => {
                  let obj = {};
                  obj.value = x[vm.widgetFormSelect.options.filter(item => item.attrName == "dynamicChange")[0].list[0].Value];
                  obj.label = x[vm.widgetFormSelect.options.filter(item => item.attrName == "dynamicChange")[0].list[0].Label];
                  return obj;
                });
                resolve(optionData);
              }
            })
            .catch(err => {
              vm.$message.error(err.msg);
            });
          }
        },
        optionProvince(resolve) {
          resolve(vm.dynamicData.optionProvince);
        },
        optionCity(resolve) {
          resolve(vm.dynamicData.optionCity);
        },
        optionDistrict(resolve) {
          resolve(vm.dynamicData.optionDistrict);
        },
        funcGetToken(resolve) {
          request
            .get("http://tools-server.xiaoyaoji.cn/api/uptoken")
            .then(res => {
              resolve(res.uptoken);
            });
        },
        upload_callback(response, file, fileList) {
          console.log("callback", response, file, fileList);
        }
      },
      widgetModels: {},
      isMobel: false,
      Tab: "PC",
      mobelComponent: [],
      dynamicData: {
        optionProvince: this.province, // 省 option data
        optionCity: [], // 市 option data
        optionDistrict: [] // 区 option data
      },
      func: function() {},
      refers:0
    };
  },
  watch: {
    isMobel: function(value) {
      if (value) {
        document.getElementsByTagName("html")[0].style.fontSize = "50.4px";
      } else {
        document.getElementsByTagName("html")[0].style.fontSize = "16px";
      }
      this.refers++
    }
  },
  mounted() {
    document.getElementsByClassName("fm2-container")[0].style.height =
      document.documentElement.clientHeight -
      document.getElementsByClassName("el-dialog__header")[0].clientHeight -
      175 +
      "px";
  },
  methods: {
    /**
     *宋建国：2020/2/11 16:13
     *描述：刷新方法
     *版本：1.0
     */
    refreshkeyAdd() {
      if (!this.$tu.isObjectBlank(this.$store.getters.DragRouterViewThis)) {
        this.$store.getters.DragRouterViewThis.refresh();
      } else {
        this.refreshkey++;
        /* this.$message.info("请在根容器中注册跟实例,注册方法store.commit(\"setDragRouterViewThis\", this)");
          return;*/
      }
      //;
    },
    distinct(arr, name) {
      var hash = {};
      return arr.reduce(function(item, next) {
        hash[next[name]] ? "" : (hash[next[name]] = true && item.push(next));
        return item;
      }, []);
    },
    handleConfigSelect(value) {
      this.configTab = value;
    },
    handleMoveEnd(evt) {
      console.log("end", evt);
    },
    handleMoveStart({ oldIndex }) {
      console.log("start", oldIndex, this.basicComponents);
    },
    handleMove(evt) {
      return true;
    },
    handlePreview() {
      this.previewVisible = true;
    },
    previewClose() {
      this.previewVisible = false;
    },
    handleClear() {
      this.widgetForm = {
        list: [],
        config: {
          labelWidth: 100,
          labelPosition: "right",
          size: "small",
          customClass: "",
          height: ""
        }
      };
      this.widgetFormSelect = {};
    },
    //			用于外部获取数据
    getJSON() {
      return this.widgetForm;
    },
    //			外部获取html代码
    getHtml() {
      return createVue(JSON.stringify(this.widgetForm),this.keepaliveName);
    },
    setJSON(json) {
      this.widgetForm = json;

      if (json.list.length > 0) {
        this.widgetFormSelect = json.list[0];
      }
    },
    handleDataChange(field, value, data) {
      console.log(field, value, data);
    },
    /**
     *宋建国：2019/12/27 12:14
     *描述：初始化可拖拽业务组件
     *版本：1.0
     */
    initComponent() {
      this.$api.component
        .AllComponent(this, 0)
        .then(response => {
          this.allComponents = this.allComponents.concat(response);
          this.allComponents = this.distinct(this.allComponents, "label");
          this.comploading = false
        })
        .catch(err => {
          this.comploading = false
          this.$message.error(err);
        });
    },
    initMobelComponent() {
      this.$api.component
        .AllComponent(this, 1)
        .then(response => {
          this.mobelComponent = this.mobelComponent.concat(response);
          this.mobelComponent = this.distinct(this.mobelComponent, "label");
          this.comploading = false
        })
        .catch(err => {
          this.comploading = false
          this.$message.error(err);
        });
    },
    onProvinceChange(value) {
      console.log(this.widgetForm.list.filter(item => item.type == "select"));
      this.dynamicData.optionCity = [];
      this.dynamicData.optionDistrict = [];
      this.dynamicData.optionCity = this.province.filter(city => {
        return city.text === value;
      })[0].children;
      this.widgetForm.list
        .filter(item => item.type == "select")
        .forEach(x => {
          if (
            x.options.filter(
              v => v.list && v.list[0].remoteFunc == "optionCity"
            ).length > 0
          ) {
            x.options.filter(
              n => n.attrName == "remoteOptions"
            )[0].value = this.province.filter(city => {
              return city.text === value;
            })[0].children;
            x.options.filter(n => n.attrName == "hide")[0].value = false;
          }
        });
    },
    onCityChange(value) {
      this.dynamicData.optionDistrict = [];
      // this.dynamicData.optionDistrict = this.dynamicData.optionCity.filter(region => { return region.text === value; })[0].children;
    }
  },
  created() {
    this.comploading = true
    this.initComponent();
    this.initMobelComponent();
  }
};
</script>

<style lang="scss" scoped>
.widget-empty {
  background-position: 50%;
}

/deep/ .components-list .form-edit-widget-label {
  width: 47% !important;
}
.tabstyle {
  width: 120px;
}
#bgMobel {
  position: absolute;
  top: 0;
  left: 0;
  width: 800px;
}
.mobelWidth {
  width: 414px;
  margin: 0 auto;
}
.container-div {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/vueformmaking/Container.vue